import { forwardRef } from 'react';
import { TextFieldProps } from '@mui/material';
import deepmerge from '@mui/utils/deepmerge';
import { LibTextfieldProps, Textfield } from '../TextFields';
import styles from './styles';

const LibTextFieldUnderlined = forwardRef(
  (
    props: LibTextfieldProps & Partial<TextFieldProps>,
    ref: React.ForwardedRef<any>
  ) => <Textfield {...props} ref={ref} sx={deepmerge(props.sx, styles.root)} />
);

LibTextFieldUnderlined.displayName = 'LibTextFieldUnderlined';

export default LibTextFieldUnderlined;
